import React from "react";
import { ImCancelCircle } from "react-icons/im";
import "../../../Styles/userProfile.css";


const StaffPermission =({ openModal }: any) => {
  return (
    <div className="modal">
      <div className="permissionModal">
        <div className="catModalTop">
          <h4>Staff Permission</h4>
          <ImCancelCircle className="catCancel" onClick={openModal} />
        </div>
        <div className="line"></div>

        <div className="permision">
          {/* <p>Make Requisition</p> */}
          <p>View All Report</p>
          <p>Generate Loading Slip</p>
          <p>Make Requisition</p>
        </div>

        <div className="catModalBtn">
          <button className="catBtn2" onClick={openModal}>
            Back
          </button>
        </div>
      </div>
    </div>
  );
}

export default StaffPermission